<template>
  <transition name="fade">
    <div v-if="show" class="page-loader">
      <div class="loader-content">
        <!-- 圆形进度加载器 -->
        <div class="spinner-wrapper">
          <svg class="circular-spinner" viewBox="25 25 50 50">
            <circle
              class="path"
              cx="50"
              cy="50"
              r="20"
              fill="none"
              stroke-width="3"
            />
          </svg>
        </div>

        <!-- 加载文字 -->
        <div class="loading-text">{{ text }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PageLoader',
  props: {
    show: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: '加载中...'
    }
  }
}
</script>

<style scoped>
.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-content {
  text-align: center;
}

/* 圆形进度条 */
.spinner-wrapper {
  width: 50px;
  height: 50px;
  margin: 0 auto 20px;
}

.circular-spinner {
  width: 100%;
  height: 100%;
  animation: rotate 2s linear infinite;
}

.path {
  stroke: #1677ff;
  stroke-linecap: round;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% { transform: rotate(360deg); }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

.loading-text {
  font-size: 14px;
  color: #666;
}

/* 淡入淡出 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
